module.exports = __webpack_public_path__ + "img/yapportfolio.1cf69747.jpg";